module.exports = __webpack_public_path__ + "img/cpscb.8a4c07a9.png";